namespace GeniuzPOS.Administration {
    export enum PsParaGenTypeSalesDocFg {
        SalesDocFg1 = 1,
        SalesDocFg2 = 2,
        SalesDocFg3 = 3
    }
    Serenity.Decorators.registerEnumType(PsParaGenTypeSalesDocFg, 'GeniuzPOS.Administration.PsParaGenTypeSalesDocFg', 'Administration.PsParaGenTypeSalesDocFg');
}
